const hybridsBtn = document.getElementById("hybridsBtn");
const hybridsCancelButton = document.getElementById("hybridsCancelBtn");
const hybridsDialog = document.getElementById("hybridsDialog");


hybridsBtn?.addEventListener("click", () => {
  hybridsDialog.showModal();
});

hybridsCancelButton?.addEventListener("click", () => {
  hybridsDialog.close();
});

hybridsDialog.addEventListener("click", (event) => {
  if (event.target === hybridsDialog) {
    hybridsDialog.close();
  }
});

const sizeGuideBtn = document.getElementById("sizeGuideBtn");
const cancelButton = document.getElementById("sizeGuideCancelBtn");
const dialog = document.getElementById("sizeGuideDialog");

sizeGuideBtn?.addEventListener("click", () => {
  dialog.showModal();
});

cancelButton?.addEventListener("click", () => {
  dialog.close();
});

dialog.addEventListener("click", (event) => {
  if (event.target === dialog) {
      dialog.close();
  }
});
// PRODUCT PAGE PRICING - MATERIAL RADIO BUTTONS
const memoryFoam = document.querySelector('.zin-memory-foam');
const hybrid = document.querySelector('.zin-hybrid');

const memoryFoamMobile = document.querySelector('.zin-memory-foam-mobile');
const hybridMobile = document.querySelector('.zin-hybrid-mobile');

const materialMemoryFoam1 = document.querySelector('.zin-material-memory-foam-1');
const materialMemoryFoam2 = document.querySelector('.zin-material-memory-foam-2');

const materialHybrid1 = document.querySelector('.zin-material-hybrid-1');
const materialHybrid2 = document.querySelector('.zin-material-hybrid-2');

const memoryFoamRadioButton = document.querySelector('.zin-material-radio-1 .zin-material-label');
const hybridRadioButton = document.querySelector('.zin-material-radio-2 .zin-material-label');

memoryFoamRadioButton?.addEventListener('click', () => {
  memoryFoam.classList.remove('hidden');
  memoryFoamMobile.classList.remove('hidden');

  hybrid.classList.add('hidden');
  hybridMobile.classList.add('hidden');

  materialMemoryFoam1.classList.remove('hidden');
  materialHybrid1.classList.add('hidden');
  materialMemoryFoam2.classList.remove('hidden');
  materialHybrid2.classList.add('hidden');

});

hybridRadioButton?.addEventListener('click', () => {
  memoryFoam.classList.add('hidden');
  memoryFoamMobile.classList.add('hidden');

  hybrid.classList.remove('hidden');
  hybridMobile.classList.remove('hidden');

  materialMemoryFoam1.classList.add('hidden');
  materialHybrid1.classList.remove('hidden');
  materialMemoryFoam2.classList.add('hidden');
  materialHybrid2.classList.remove('hidden');
});
setTimeout(function() {
  var currentURL = window.location.href;
  let checkZinus = document.querySelector('.zinus-original');
  if(checkZinus && currentURL.includes('40316113')){
    document.querySelector('.ultra-cooling-green-tea').classList.add('hidden');
    document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
    document.querySelector('.cooling-green-tea').classList.remove('opacity');
  }else if(checkZinus && currentURL.includes('4032118')){
    document.querySelector('#zinusOriginalRadio').classList.add('hidden');
    document.querySelector('.ultra-cooling-green-tea').classList.remove('opacity');
    document.querySelector('.cooling-green-tea').classList.remove('opacity');
    document.querySelector('.cooling-green-tea .most_popular').classList.add('hidden');
    document.querySelector('.cooling-green-tea .compare_at_price').classList.add('hidden');
  }else if(checkZinus && currentURL.includes('4040070')){
    document.querySelector('.pdp-variant-1-text').classList.add('hidden');
    document.querySelectorAll('.zin-radio__button').forEach(item=>{
      item.classList.add('hidden');
    })
    document.querySelectorAll('.zin-radio__button').forEach(item=>{
      item.classList.remove('opacity');
    })
  }
}, 1000);
// PDP TABS

document.addEventListener("DOMContentLoaded", function () {
  const upgradesButtons = document.querySelectorAll('.zin-upgrades-radio__input');
  const radioButtons = document.querySelectorAll('.zin-radio__input');
  const sizeInput = document.getElementById('template--14829461962815__main-7269091967039-option-3');
  const pdpTabOne = document.querySelector('#tabOne');

  const zinusOriginalRadio = document.querySelector('#zinusOriginalRadio')
  let filteredData;

  function filterObjectByMaterial(obj, material) {
    const result = {};
    for (const key in obj) {
      if (key.includes(material)) {
        result[key] = obj[key];
      }
    }
    return result;
  }

  function currentUpgrade() {
    const allUpgrades = document.querySelectorAll('.zin-upgrades-radio__input');
    // console.log('allUpgrades: ', allUpgrades)
    const checkedUpgrade = document.querySelector('.zin-upgrades-radio__input:checked');
    // console.log('checkedUpgrade: ', checkedUpgrade.value)
    return checkedUpgrade ? checkedUpgrade.value : null;
  }
  
  function currentMaterial() {
    const allMaterials = document.querySelectorAll('.zin-radio__input');
    const checkedRadioButton = document.querySelector('.zin-radio__input:checked');
    return checkedRadioButton ? checkedRadioButton.value : null;
  }


  document.querySelectorAll(".variant_radio_input").forEach(element => {
    element.addEventListener('click', function(){
      let selectedVariant= [];
      let filterVariantText = '';
      let productPrice = [];
      let premierSelectedVariant= [];
      let variantTotalPrice= [];
      let variantPrice = [];
      let variantTitles = [];
      let premierVariantPrice = [];
      let zinusPrice = '';
      let premierPrice = '';
      let selectedPopout = document.querySelector('.select-popout__value')?.dataset.popoutText;
      let firstRadioValue = '';
      let secondRadioValue = '';
      let productTitle = '';
    
      document.querySelectorAll('.zin-radio__button:not(.hidden)').forEach((radioButton, i) => {
        if(i == 0){
          firstRadioValue = radioButton.querySelector('input').value;
        }else{
          secondRadioValue = radioButton.querySelector('input').value;
        }
        
      })
      document.querySelectorAll(".variant_radio_input:checked").forEach(item => {
        let variantValue = item.value;
        let filterText = item.dataset.variantFilter;
        selectedVariant.push(variantValue);
        filterVariantText += '-'+filterText;
        if(variantValue == firstRadioValue){
          premierSelectedVariant.push(secondRadioValue)
        }else{
          premierSelectedVariant.push(variantValue);
        }
      })

      let filterValue = filterVariantText.substring(1).trim();

      if(filterValue.includes('hybrid')){
        document.querySelector('#hybrid').click();
        if(window.screen.width < 767 && !document.querySelector('.product-gallery-hybrid').classList.contains('swiper-container-initialized')){
          var galleryProductHybrid = new Swiper(`.product-gallery-hybrid`, {
              loop: false,
              spaceBetween: 10,
              slidesPerView: 1.15,
              pagination: {
                  el: '.swiper-pagination',
              },
          });

          function handleFocus(e, i) {
              galleryProductHybrid.slideTo(i);
          }

        const iconHybridSliders = document.querySelectorAll('.product-gallery-hybrid .swiper-slide');
        iconHybridSliders.forEach((slide, i) => slide.addEventListener('focusin', (e) => handleFocus(e, i)));
        }
      }else{
        document.querySelector('#memory_form')?.click();
      }
      
      document.querySelectorAll('.find-product-property .property-wrapper')?.forEach(property => {
        property.classList.remove('active');
      })
      document.querySelector(`.find-product-property [data-variant-text="${filterValue}"]`)?.classList.add('active');

      if(document.querySelector('.product-size-guide')){
        document.querySelectorAll('.product-size__info').forEach(item =>{
          item.classList.add('hidden');
        })
        document.querySelectorAll(`.size-guide-wrapper [data-variant-title="${filterValue}"]`).forEach(item => {
          item.classList.remove('hidden');
        })
      }
      
      console.log(filterValue, 'filterValue');

      document.querySelectorAll('.mobile-property-wrapper')?.forEach(mobileElement =>{
        mobileElement.classList.remove('active');
      })

      document.querySelector(`.find-product-property [data-mobile-variant-text="${filterValue}"]`)?.classList.add('active');

      if(window.screen.width < 767 && !document.querySelector(`[data-mobile-variant-text="${filterValue}"] .swiper-container`)?.classList.contains('swiper-container-initialized')){
        var propertGallery = new Swiper(`[data-mobile-variant-text="${filterValue}"]  .swiper-container`, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: `[data-mobile-variant-text="${filterValue}"] .swiper-pagination`,
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '" data-pagination-index="'+(index+1)+'"></span>';
            },
            onTouchMove: function(swiper, event) {
              console.log('touchmove')
            },
          },
        });

        function propertyHandleFocus(e, i) {
            propertGallery.slideTo(i);
        }
        let propertySliders;
        if(document.querySelectorAll(`[data-mobile-variant-text="${filterValue}"] .property-image .swiper-slide`)){
          propertySliders = document.querySelectorAll(`[data-mobile-variant-text="${filterValue}"] .property-image .swiper-slide`);
        }
        
        propertySliders.forEach((slide, i) => slide.addEventListener('focusin', (e) => propertyHandleFocus(e, i)));

        document.querySelector('.mobile-property-wrapper.active .option-with-descriptions .swiper-pagination')?.querySelectorAll('.swiper-pagination-bullet').forEach(element =>{
            element.addEventListener('click', function(){
                let number = element.dataset.paginationIndex;
                  document.querySelectorAll('.mobile-property-wrapper.active .options-wrapper .option-item').forEach(property => {
                  property.querySelector('.option-number').classList.remove('active');
                })
                document.querySelector(`.mobile-property-wrapper.active [data-index="${number}"] .option-number`).classList.add('active');
            })
        })
      }

      document.querySelectorAll('.mobile-property-wrapper.active .options-wrapper .option-item').forEach(option => {
          option.addEventListener('click', function(){
              let index = option.dataset.index.trim();
              console.log(index, 'index');
              document.querySelector(`.mobile-property-wrapper.active [data-pagination-index="${index}"]`).click();
          })
      })

      
      document.querySelectorAll('.product-variant__image')?.forEach(element => {
        element.closest('.product-wrapper__item').querySelector('.atc_button').classList.add('hidden');
        element.closest('.product-wrapper__item').querySelector('.shop_now').classList.remove('hidden');
      })

      document.querySelector(`.find-perfect-product [data-variant-text="${filterValue}"]`)?.closest('.product-wrapper__item')?.querySelector('.shop_now').classList.add('hidden');
      document.querySelector(`.find-perfect-product [data-variant-text="${filterValue}"]`)?.closest('.product-wrapper__item')?.querySelector('.atc_button').classList.remove('hidden');

      productTitle += selectedVariant[0];

      for (let key = 0; key<selectedVariant.length; key++){
        if(selectedVariant[key].includes('Hybrid')){
            productTitle += '- Hybrid'
        }
      }
      let customProductTitle = productTitle.replace('-', '');
      console.log(customProductTitle, 'customProductTitle');


      
      if(customProductTitle.includes('Hybrid')){
        document.querySelectorAll('.original_image').forEach(origianlImage => {
          origianlImage.classList.add('hidden');
        })
        document.querySelectorAll('.hybrid_image').forEach(hybridImage => {
          hybridImage.classList.remove('hidden');
        })
        document.querySelector('#hybrid-1').click();
      }else{
        document.querySelectorAll('.original_image').forEach(origianlImage => {
          origianlImage.classList.remove('hidden');
        })
        document.querySelectorAll('.hybrid_image').forEach(hybridImage => {
          hybridImage.classList.add('hidden');
        })
        document.querySelector('#memory_form-1').click();
      }
      
      document.querySelectorAll('.custom_product_title').forEach(button => {
        button.value = customProductTitle;
      })

      document.querySelectorAll('.product__title').forEach(title => {
        title.innerHTML = productTitle;
      })

      let filterImageValue = productTitle.trim().replaceAll(' ', '-');

      document.querySelector('.filter-variant__images').dataset.filter = productTitle.trim().replaceAll(' ', '-');

      console.log(selectedVariant, 'selectedVariant');


      document.querySelectorAll('.product-single__gallery').forEach(gallery => {
        gallery.classList.remove('active');
        if(gallery.getAttribute('data-tag') == filterImageValue) {
          gallery.classList.add('active');
          gallery.classList.remove('opacity');
          if(!gallery.querySelector('.swiper-container').classList.contains('swiper-container-initialized')) {
            var galleryThumbs = new Swiper(`[data-tag="${filterImageValue}"] .gallery-thumbs`, {
              centeredSlides: true,
              spaceBetween: 10,
              slideToClickedSlide: true,
              slidesPerView: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
            });

            var galleryTop = new Swiper(`[data-tag="${filterImageValue}"]  .gallery-top`, {
              loop: true,
              loopedSlides: 1,
              navigation: {
                nextEl: `[data-tag="${filterImageValue}"] .swiper-button-next`,
                prevEl: `[data-tag="${filterImageValue}"] .swiper-button-prev`,
              },
              pagination: {
                el: `[data-tag="${filterImageValue}"] .swiper-pagination`,
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '" data-pagination-index="'+(index+1)+'"></span>';
                },
              },
            });

            document.querySelector('.product-single__gallery.active .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
              slider.addEventListener('click', function(){
                let index = this.querySelector('.product-single__thumbnail').dataset.number;
                document.querySelector('.product-single__gallery.active').querySelector(`[data-pagination-index="`+index+`"`).click();
              })
            })
          }
        }
      });

      document.querySelectorAll(".variant_item").forEach(variantItem => {
        let variantTitle = variantItem.dataset.variantTitle;
        let flag = 0;
        let premierFlag = 0;
        for (let key = 0; key<selectedVariant.length; key++) {
          if(selectedVariant[key] == 'Ultra Cooling Green Tea'){
            selectedVariant[key] = "Ultra Coolings Green Tea"
          }

          if(variantTitle.includes('Ultra Cooling Green Tea')){
            let newVariantTitle = variantTitle.replace('Ultra Cooling Green Tea', 'Ultra Coolings Green Tea');
            if (!newVariantTitle.includes(selectedVariant[key])) {
              flag = 1;
            }
          }else{
              if (!variantTitle.includes(selectedVariant[key])) {
              flag = 1;
            }
          }
        }

        for (let key = 0; key<premierSelectedVariant.length; key++) {
          if(premierSelectedVariant[key] == 'Ultra Cooling Green Tea'){
            premierSelectedVariant[key] = "Ultra Coolings Green Tea"
          }

          if(variantTitle.includes('Ultra Cooling Green Tea')){
            let newVariantTitle = variantTitle.replace('Ultra Cooling Green Tea', 'Ultra Coolings Green Tea');
            if (!newVariantTitle.includes(premierSelectedVariant[key])) {
              premierFlag = 1;
            }
          }else{
              if (!variantTitle.includes(premierSelectedVariant[key])) {
              premierFlag = 1;
            }
          }
        }


        if(variantTitle.includes(selectedPopout)){
          productPrice.push(variantItem.dataset.variantPrice);
        }
        document.querySelectorAll('.product-wrapper__item').forEach((item, index)=>{
          item.querySelector('.variant-details .price-with-button .variant_price').innerHTML = productPrice[index];
        })

        document.querySelectorAll('.products-wrapper:not(.megamenu)').forEach((element, num) => {
          element.querySelectorAll('.product-wrapper__item').forEach((item, number) =>{
            if(num == 0){
              let num = number*2;
              item.querySelector('.variant-details .price-with-button .variant_price').innerHTML = productPrice[num];
              if(!productPrice[num]){
                item.querySelector('.variant-details .price-with-button .variant_price').classList.add('hidden');
              }else{
                item.querySelector('.variant-details .price-with-button .variant_price').classList.remove('hidden');
              }
            }

            else{
              let num = number*2+1;
              item.querySelector('.variant-details .price-with-button .variant_price').innerHTML = productPrice[num];
              if(!productPrice[num]){
                item.querySelector('.variant-details .price-with-button .variant_price').classList.add('hidden');
              }else{
                item.querySelector('.variant-details .price-with-button .variant_price').classList.remove('hidden');
              }
            }
            
          })
        })

        if(flag == 0){
          if(variantTitle.includes(selectedPopout)){
            zinusPrice = variantItem.dataset.variantPrice;
            let variantAvailable = variantItem.dataset.available;
            let variantOrderAvailable = variantItem.dataset.orderAvailable;
            let variantOrderDescription = variantItem.dataset.orderDescription;
            let variantShippingDate = variantItem.dataset.expectedDate;
            let variantOrderButton = variantItem.dataset.orderButton;
            let variantQuantity = variantItem.dataset.qty;
            let variantID = variantItem.dataset.variantId;
            console.log(zinusPrice, variantAvailable);

            let mattressHeight = variantItem.dataset.height;
            console.log(mattressHeight, 'mattressHeight');
            document.querySelector(".selected_option .option_price").textContent = zinusPrice;
            document.querySelectorAll('.mattress-height').forEach(button => {
              button.value = mattressHeight;
            })
            document.querySelector('.product__submit__item.atc_button:not(.hidden)').closest('.price-with-button').querySelector('input[name="id"]').value = variantID;
            if(variantAvailable == 'true'){
              if(document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled){
                if(variantQuantity < 1 && variantOrderAvailable){
                  console.log('start1');
                  document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Pre Order';
                }else{
                  document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Add to Cart';
                }
                
                document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled  = false;
              }else{
                setTimeout(changeButtontext, 300);
                function changeButtontext(){
                  if(variantQuantity < 1 && variantOrderAvailable){
                    document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Pre Order';
                  }else{
                    document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML ='Add to Cart';
                    document.querySelectorAll('.mattress-wrapper').forEach(item =>{
                      item.innerHTML = '';
                    });
                  }
                }
              }
              console.log(variantQuantity, 'variantQuantity');
              if(variantQuantity < 1 && variantOrderAvailable){
                document.querySelector('.variant__countdown--in').textContent = 'Item is Pre Order';
                document.querySelector('.order-expected_date')?.classList.remove('hidden');
                document.querySelector('.custom_add-button').textContent = 'Pre Order';
                document.querySelectorAll('.mattress-pre-order')?.forEach(order => {
                  order.value = 'This item is a Pre-Order';
                })
                setTimeout(changeButton, 100);
                function changeButton() {
                  document.querySelector('.product_add_to_cart-button [data-add-to-cart-text]').textContent = variantOrderButton;
                }

                document.querySelector('.pre-order__description').textContent = variantOrderDescription;
                document.querySelector('.pre-order__shipping-date').textContent = variantShippingDate;
                document.querySelector('.order-expected_date').textContent = variantShippingDate;
                document.querySelector('.pre-order-wrapper')?.classList.remove('hidden');
              }
              if(variantQuantity > 0){
                document.querySelector('.order-expected_date')?.classList.add('hidden');
                document.querySelector('.product__form__wrapper').classList.remove('variant--soldout');
                document.querySelector('.custom_add-button').textContent = 'Add To Cart';
                document.querySelector('.pre-order-wrapper')?.classList.add('hidden');
                document.querySelector('.order-expected_date').classList.add('hidden');
                document.querySelector('.variant__countdown--in').textContent = 'Item is in stock';
              }
            }else{
              console.log('123');
              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('[data-add-to-cart]').innerHTML = 'Sold Out';

              document.querySelector('.product__submit__item.atc_button:not(.hidden)').querySelector('.product__submit__add').disabled  = true;
                
              document.querySelector('.order-expected_date')?.classList.add('hidden');
              document.querySelector('.pre-order-wrapper')?.classList.add('hidden');
              document.querySelector('.order-expected_date').classList.remove('hidden');
              document.querySelector('.product__form__wrapper').classList.add('variant--soldout');
              document.querySelector('.custom_add-button').textContent = 'Sold Out - Notify Me When It’s Available';
              document.querySelectorAll('.mattress-order-expected_date')?.forEach(order => {
                order.value = '';
              })
              document.querySelectorAll('.mattress-pre-order')?.forEach(order => {
                order.value = '';
              })
            }
          }
          variantPrice.push(variantItem.dataset.variantPrice);
          variantTitles.push(variantItem.dataset.variantTitle);
          variantTotalPrice.push(variantItem.dataset.totalValue);
          document.querySelector('#tabOne').innerHTML= variantItem.querySelector('.tab_one').innerHTML;
          document.querySelector('#tabTwo').innerHTML = variantItem.querySelector('.tab_two').innerHTML;
          document.querySelector('#tabThree').innerHTML = variantItem.querySelector('.tab_three').innerHTML;
        }
        if(premierFlag == 0){
          if(variantTitle.includes(selectedPopout)){
            premierPrice = variantItem.dataset.variantPrice;
          }
          premierVariantPrice.push(variantItem.dataset.variantPrice);
        }
      })
      

      let rest = parseFloat(premierPrice.replace(/[^0-9.-]+/g,"")) - parseFloat(zinusPrice.replace(/[^0-9.-]+/g,""));
      let restPrice =''
      if(rest > 0){
        restPrice = '+'+premierPrice.match(/[a-zA-Z$]+/g)+rest;
      }
      document.querySelectorAll('.compare_at_price').forEach(price => {
        if(!price.closest('.zinusPremierRadio').classList.contains('hidden')){
          price.textContent = restPrice;
        }
      })
      let optionIndex = 0; 
      document.querySelectorAll(".select-popout__list__scroll .price-with-total").forEach((item, i) => {
        let filterText = item.closest('.select-popout__option').dataset.value;
        let available = 0;
        filterText = '/ '+filterText;
        let hasText = variantTitles.some(item => item.includes(filterText));
        if(hasText){
          available = 1;
        }
        if(available == 1){
          item.querySelector('.option_price').innerHTML = variantPrice[optionIndex];
          optionIndex = optionIndex+1;
          item.closest('.select-popout__item').classList.remove('hidden');
        }else{
          item.closest('.select-popout__item').classList.add('hidden');
        }
        
      })
    })
  })

  document.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(button => {
    button.addEventListener('click', function(){
      let optionPrice = this.querySelector('.option_price').innerHTML;
      let totalPrice = this.querySelector('.total_price').innerHTML;
      let popoutText = this.querySelector('.select-popout__option').dataset.value;
      if (!totalPrice.includes('$0.00')) {
        document.querySelector('.selected_option .total_price').innerHTML = totalPrice;
      }
      document.querySelector('.selected_option .option_price').innerHTML = optionPrice;
      console.log(popoutText, 'popoutText');
      document.querySelector('.select-popout__value')?.setAttribute('data-popout-text', popoutText);
      document.querySelectorAll('.zin-radio__button').forEach(zinButton => {
        if(zinButton.querySelector('input').checked){
          zinButton.querySelector('input').click();
        }
      })

      if(this.closest('.sticky-atc') && window.innerWidth < 767) {
        document.querySelector('.sticky-atc .select-popout__list').classList.add('select-popout__list--visible');
        document.querySelector('.sticky-atc .select-popout__toggle').setAttribute('aria-expanded', true);
      }
    })
  })

  document.querySelectorAll('.zin-radio__button').forEach(radioButton => {
    if(radioButton.querySelector('input').checked){
      radioButton.querySelector('input').click();
    }
  })

  document.querySelector('.custom_add-button').addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.product__submit__holder .product__submit__buttons .product__submit__add').click();
  })

});

window.onload = (event) => {
const stickyATC = document.querySelector('.sticky-atc');
var formHeight = 0;
function triggerStickyAtc() {
  let formBottom = document.querySelector('.product-submit-form').offsetTop + document.querySelector('.product-submit-form').offsetHeight
  if(window.scrollY > formBottom - 100 && !document.getElementById('SiteHeader').classList.contains('sticky-form')) {
    document.getElementById('SiteHeader').classList.add('sticky-form');
    document.querySelector('body').classList.add('sticky-add-to-cart');
    stickyATC.appendChild(document.querySelector('.product__title-and-price'));
    stickyATC.appendChild(document.querySelector('.product__form__wrapper'));
  }
  if(!document.querySelector('.product-submit-form').querySelector('.product__form__wrapper')) document.querySelector('.product-submit-form').style.minHeight = `${formHeight}px`;
  else {
    formHeight = document.querySelector('.product-submit-form').querySelector('.product__form__wrapper').offsetHeight;
    document.querySelector('.product-submit-form').style.minHeight = 0;
  }
  if(window.scrollY <= formBottom - 100 && document.getElementById('SiteHeader').classList.contains('sticky-form')) {
    document.getElementById('SiteHeader').classList.remove('sticky-form');
    document.querySelector('body').classList.remove('sticky-add-to-cart');
    document.querySelector('.form__wrapper').prepend(document.querySelector('.product__title-and-price'));
    document.querySelector('.product-submit-form').prepend(document.querySelector('.product__form__wrapper'));
  }
}
window.addEventListener("scroll", (event) => {
    triggerStickyAtc();
    if(window.innerWidth < 767){
      const netomiIcon = querySelector('#netomiChatWindow');
      netomiIcon.style.visibility = 'hidden';
    }
});


triggerStickyAtc();


document.querySelectorAll('.select-popout__item').forEach(item => {
  item.addEventListener('click', function(){
    if(this.classList.contains('sold-out')) {
      document.querySelector('.product__form__wrapper').classList.add('variant--soldout');
      document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
        atc.textContent = 'Sold Out - Notify Me When It\'s Available';
      });
    }
    else {
      document.querySelector('.product__form__wrapper').classList.remove('variant--soldout');
      document.querySelectorAll('[data-add-to-cart-text]').forEach(atc => {
        atc.textContent = 'Add to Cart';
      });
    }
  });
});

document.querySelector('.select-popout__list-close')?.addEventListener('click', function(){
  document.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
  document.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
});
};

var galleryThumbs = new Swiper(`.product-single__gallery.active .gallery-thumbs`, {
centeredSlides: true,
spaceBetween: 10,
slideToClickedSlide: true,
slidesPerView: 8,
watchSlidesVisibility: true,
watchSlidesProgress: true,
});

var galleryTop = new Swiper(`.product-single__gallery.active  .gallery-top`, {
loop: true,
loopedSlides: 1,
spaceBetween: 10,
navigation: {
  nextEl: `.product-single__gallery.active .swiper-button-next`,
  prevEl: `.product-single__gallery.active .swiper-button-prev`,
},
pagination: {
  el: ".product-single__gallery.active .swiper-pagination",
  clickable: true,
  renderBullet: function (index, className) {
    return '<span class="' + className + '" data-pagination-index="'+(index+1)+'"></span>';
  },
},
});

document.querySelector('.product-single__gallery.active .gallery-thumbs')?.querySelectorAll('.swiper-slide').forEach(slider => {
slider.addEventListener('click', function(){
  let index = this.querySelector('.product-single__thumbnail').dataset.number;
  document.querySelector('.product-single__gallery.active').querySelector(`[data-pagination-index="`+index+`"`).click();
  
})
})

document.querySelectorAll('.product-media__image').forEach(media => {
media.addEventListener('click', function(){
  if(media.classList.contains('active')){
    media.classList.remove('active');
  }else{
    media.classList.add('active');
  }
  media.addEventListener('mousemove', function zoomImage(event){
    zoom(event);
  })
})
})

function zoom(e){
var zoomer = e.currentTarget;
e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
x = offsetX/zoomer.offsetWidth*100
y = offsetY/zoomer.offsetHeight*100
zoomer.style.backgroundPosition = x + '% ' + y + '%';
}